import Error from 'next/error';
import Link from 'next/link';
import { destroyCookie } from 'nookies';
import { cookies } from 'utils/constants';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

export default function nonAuth(Component) {
  const Wrapper = ({ statusCode, ...props }) => {
    const router = useRouter();

    useEffect(() => {
      if (statusCode === 403) {
        destroyCookie(null, cookies.token);
        router.push('/');
      }
    }, [statusCode, router]);

    if (statusCode && statusCode !== 403) {
      return (
        <>
          <Error statusCode={statusCode} />
          <p className="fixed w-full top-1/2 mt-48 text-center">
            Back to <Link passHref href="/">Homepage</Link>
          </p>
        </>
      );
    }

    return <Component {...props} />;
  };

  Wrapper.getLayout = Component.getLayout || ((page) => page);

  return Wrapper;
}
